import React, { memo, useState } from 'react';
import { bool, number, string, func } from 'prop-types';
import { ErrorInput as StorybookErrorInput } from '@sunbeltrentals/sbr-global-components';
import Button from '../button';
import Input from '../input';
import './password.scss';

const Password = props => {
    const [showPassword, setShowPassword] = useState(false);
    const {
        label,
        id,
        name,
        value,
        handleInputChange,
        errorMsg,
        dataTestId,
        maxLength,
        onFocus = () => {},
        required = false
    } = props;

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const handleFocus = e => {
        onFocus && onFocus(e);
    };
    return (
        <div className="password">
            {label && (
                <label
                    htmlFor={id}
                    className={`password__label ${required && 'requiredSymbol'} ${
                        errorMsg ? 'errorPasswordLabel' : ''
                    }    `}>
                    {label}
                </label>
            )}
            <div className={`password__input-wrap ${errorMsg ? 'password__input-border' : ''}`}>
                <Input
                    fieldcustomclass={'password__field'}
                    value={value}
                    type={showPassword ? 'text' : 'password'}
                    classes={'password__input'}
                    name={name}
                    dataTestId={dataTestId}
                    handleInputChange={handleInputChange}
                    inputAriaRequired={true}
                    maxLength={maxLength}
                    onFocus={handleFocus}
                />
                <Button
                    className={'password__button-show'}
                    type={'button'}
                    onClick={togglePasswordVisibility}
                    buttonAriaLabel={showPassword ? 'Hide Password' : 'Show Password'}>
                    {showPassword ? 'Hide' : 'Show'}
                </Button>
            </div>
            <StorybookErrorInput errorMsg={errorMsg} />
        </div>
    );
};

Password.propsType = {
    label: string,
    showPassword: bool,
    name: string,
    value: string,
    maxLength: number,
    onFocus: func,
    required: bool
};

Password.defaultProps = {
    label: '',
    showPassword: false,
    name: '',
    value: '',
    maxLength: 0,
    onFocus: () => {},
    required: false
};

export default memo(Password);
